/* Coffee calorie calculator (sections/msc-calories.liquid). Numbers come from the JSON config the section renders. */
(function () {
  function init(root) {
    var cfgEl = root.querySelector('[data-mscc-config]');
    if (!cfgEl) return;
    var C;
    try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var form = root.querySelector('[data-mscc-form]');
    var result = root.querySelector('[data-mscc-result]');
    var sticky = root.querySelector('[data-mscc-sticky]');
    var drinks = {}; C.drinks.forEach(function (d) { drinks[d.id] = d; });
    var milks = {}; C.milks.forEach(function (m) { milks[m.id] = m; });
    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var lastDrink = null;

    function val(name) {
      var el = form.querySelector('[name="' + name + '"]:checked') || form.querySelector('input[name="' + name + '"]:not([type="radio"])');
      return el ? el.value : null;
    }
    function setRadio(name, v) {
      var el = form.querySelector('[name="' + name + '"][value="' + v + '"]');
      if (el) el.checked = true;
    }
    function show(el, on) { if (el) el.hidden = !on; }

    function calc(d, size, shots, milkId, syrup, sugar) {
      var m = milkId && milkId !== 'none' && milks[milkId] ? milks[milkId].kcal : 0;
      var cup = d.cup || (size * C.ozMl);
      var usesShots = d.shots === 1;
      var esp = usesShots ? shots * C.shotMl : 0;
      var milkMl = 0;
      if (d.type === 'milky') milkMl = Math.max(0, cup * C.fill - esp) * d.foam;
      else if (d.type === 'fixed') milkMl = d.fixed;
      else if (d.type === 'black') milkMl = (milkId && milkId !== 'none') ? C.splashMl : 0;
      var coffee = d.id === 'filter' ? cup * C.fill * C.filterPer100 / 100 : (usesShots ? shots * C.shotKcal : 0);
      var milkK = milkMl * m / 100;
      var choc = d.choc ? C.chocKcal : 0;
      var extras = syrup * C.syrupKcal + sugar * C.sugarKcal + choc;
      return { total: Math.round(milkK + coffee + extras), milk: Math.round(milkK), coffee: Math.round(coffee), extras: Math.round(extras), choc: choc };
    }

    function syncControls(d) {
      var changed = lastDrink !== d.id;
      // sizes
      var sizeStep = q('[data-step="size"]');
      show(sizeStep, d.sizes.length > 0);
      qa('[name="size"]').forEach(function (inp) {
        var ok = d.sizes.indexOf(parseInt(inp.value, 10)) > -1;
        inp.disabled = !ok;
        var lab = form.querySelector('label[for="' + inp.id + '"]');
        if (lab) lab.hidden = !ok;
      });
      if (d.sizes.length && (changed || d.sizes.indexOf(parseInt(val('size'), 10)) === -1)) setRadio('size', d.def);
      // shots
      show(q('[data-step="shots"]'), d.shots === 1);
      // milk
      var milkStep = q('[data-step="milk"]');
      show(milkStep, d.type !== 'espresso');
      var noneInp = form.querySelector('[name="milk"][value="none"]');
      var noneLab = q('[data-milk-none]');
      var black = d.type === 'black';
      noneInp.disabled = !black; noneLab.hidden = !black;
      q('[data-milk-legend]').textContent = black ? 'Milk (a splash)' : 'Milk';
      if (changed) {
        if (black) setRadio('milk', 'none');
        else if (val('milk') === 'none' || !val('milk')) setRadio('milk', 'semi');
      }
      // step numbers stay in visual order
      var n = 1;
      qa('.mscc-step').forEach(function (st) { if (!st.hidden) { var num = st.querySelector('.mscc-step__num'); if (num) num.textContent = n++; } });
      lastDrink = d.id;
    }

    function summary(d, size, shots, milkId, syrup, sugar) {
      var parts = [];
      var name = d.label.toLowerCase();
      if (d.id === 'espresso') parts.push((shots === 2 ? 'Double' : 'Single') + ' espresso');
      else parts.push((d.sizes.length ? size + 'oz ' : '') + name + (d.shots === 1 ? ', ' + (shots === 2 ? 'double' : 'single') + ' shot' : ''));
      if (d.type !== 'espresso') {
        if (milkId === 'none') parts.push('black');
        else parts.push((d.type === 'black' ? 'splash of ' : '') + milks[milkId].label.toLowerCase().replace(' (barista)', '').replace(' (unsweetened)', '') + ' milk');
      }
      if (syrup) parts.push(syrup + ' pump' + (syrup > 1 ? 's' : '') + ' syrup');
      if (sugar) parts.push(sugar + ' sugar' + (sugar > 1 ? 's' : ''));
      var s = parts.join(', ');
      return s.charAt(0).toUpperCase() + s.slice(1);
    }

    function update() {
      var d = drinks[val('drink')] || drinks.latte;
      syncControls(d);
      var size = parseInt(val('size'), 10) || d.def;
      var shots = parseInt(val('shots'), 10) || 2;
      var milkId = d.type === 'espresso' ? 'none' : (val('milk') || 'none');
      var syrup = parseInt(val('syrup'), 10) || 0;
      var sugar = parseInt(val('sugar'), 10) || 0;
      var r = calc(d, size, shots, milkId, syrup, sugar);
      var sum = summary(d, size, shots, milkId, syrup, sugar);

      q('[data-total]').textContent = r.total;
      q('[data-summary]').textContent = sum;
      q('[data-part="milk"]').textContent = r.milk;
      q('[data-part="coffee"]').textContent = r.coffee;
      q('[data-part="extras"]').textContent = r.extras;
      q('[data-extras-label]').textContent = r.choc ? 'Chocolate & extras' : 'Extras';
      var tot = Math.max(1, r.milk + r.coffee + r.extras);
      ['milk', 'coffee', 'extras'].forEach(function (k) {
        q('[data-seg="' + k + '"]').style.width = (r[k] / tot * 100) + '%';
      });

      // compare milks
      var cmp = q('[data-compare]');
      var list = q('[data-compare-list]');
      if (d.type === 'espresso') { cmp.hidden = true; }
      else {
        cmp.hidden = false;
        q('[data-compare-title]').textContent = d.type === 'black' ? 'With a splash of milk' : 'Same drink, different milk';
        var rows = C.milks.map(function (m) { return { m: m, v: calc(d, size, shots, m.id, syrup, sugar).total }; });
        if (d.type === 'black') rows.unshift({ m: { id: 'none', short: 'Black' }, v: calc(d, size, shots, 'none', syrup, sugar).total });
        rows.sort(function (a, b) { return a.v - b.v; });
        var max = Math.max.apply(null, rows.map(function (x) { return x.v; })) || 1;
        list.innerHTML = rows.map(function (x) {
          var cur = x.m.id === milkId;
          return '<li class="mscc-compare__row' + (cur ? ' is-current' : '') + '"><span class="mscc-compare__name">' + x.m.short + '</span>' +
            '<span class="mscc-compare__track"><span class="mscc-compare__fill" style="width:' + Math.max(2, x.v / max * 100) + '%"></span></span>' +
            '<span class="mscc-compare__val">' + x.v + '</span></li>';
        }).join('');
      }

      if (sticky) {
        q('[data-sticky-summary]').textContent = sum;
        q('[data-sticky-total]').textContent = r.total;
      }
    }

    form.addEventListener('change', update);
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-inc],[data-dec]');
      if (!b) return;
      var name = b.getAttribute('data-inc') || b.getAttribute('data-dec');
      var inp = form.querySelector('[name="' + name + '"]');
      var v = parseInt(inp.value, 10) || 0;
      v = b.hasAttribute('data-inc') ? Math.min(parseInt(inp.max, 10), v + 1) : Math.max(0, v - 1);
      inp.value = v;
      update();
    });

    // sticky total on small screens while the result card is off screen
    if (sticky && 'IntersectionObserver' in window) {
      var calcSec = root.querySelector('.mscc-calc');
      var resultVisible = true, calcVisible = false;
      var mq = window.matchMedia('(max-width: 989px)');
      var sync = function () { sticky.hidden = !(mq.matches && calcVisible && !resultVisible); };
      new IntersectionObserver(function (en) { resultVisible = en[0].isIntersecting; sync(); }).observe(result);
      new IntersectionObserver(function (en) { calcVisible = en[0].isIntersecting; sync(); }).observe(calcSec);
      if (mq.addEventListener) mq.addEventListener('change', sync);
    }

    update();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.mscc'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
